import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { ITypedIds } from '../../ts/ServerApi/types/ITypedIds';
import {
  GetActionableObjectsRequest,
  IGetActionableObjectsResult
} from './types/GetActionableObjectsRequest';

// TODO: in the future, this class and the underlying API will support more action types than editPermissions
//       see http://mytableau/display/devft/getActionableObjects for details
export namespace GetActionableObjectsForAction {

  export function editPermissions(ids: ITypedIds): Promise<IGetActionableObjectsResult> {
    return WebHttpClient.sendRequests(
      RequestHelper.buildRequests(ids.ids,
        (idsBlock) => new GetActionableObjectsRequest({
          authorizables: {
            type: ids.type,
            ids: idsBlock
          }
        })
      ),
      combineResults);
  }

  function combineResults(results: IGetActionableObjectsResult[]): IGetActionableObjectsResult {
    return {
      ids: ResultHelper.combineIds(results),
      errors: ResultHelper.combineErrors(results)
    };
  }

}

export type GetActionableObjectsForAction = typeof GetActionableObjectsForAction;
